import React, { useContext, useState } from 'react';

const MapDataContext = React.createContext();
export const MapDataProvider = ({ children }) => {
  const [zoom, setZoom] = useState(5);
  const [mapCenter, setMapCenter] = useState([15.8700, 100.9925]);

  return (
    <MapDataContext.Provider value={{ zoom, setZoom, mapCenter, setMapCenter }}>
      {children}
    </MapDataContext.Provider>
  );
};

export default function useMapData() {
  const context = useContext(MapDataContext);
  return context;
}
